<template>
  <div>
    <span class="mr-auto"> Profile </span>

    <b-modal :id="id">Hello From My Modal!</b-modal>
  </div>
</template>

<script>
import { BModal } from "bootstrap-vue";
export default {
  inject: ["Reload", "props"],
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  components: {
    BModal,
  },

  methods: {},
};
</script>
